import React from 'react';

import { Idle, MainEngineNotStarted } from 'screens/shared';
import GasMainEngineStarted from './GasMainEngineStarted';

const GasIdle = () => {
  const components = [
    MainEngineNotStarted,
    GasMainEngineStarted
  ];

  return <Idle components={components} />;
};

export default GasIdle;



// WEBPACK FOOTER //
// ./src/screens/Gas/GasIdle/GasIdle.js